import * as tslib_1 from "tslib";
import { BaseApiClient } from './BaseApiClient';
export var REGIONS_ENDPOINTS = {
    ALL: '/Regions'
};
/**
 * RegionsApiClient - client for fetching regions from BFF
 * @exports
 * @class RegionsApiClient
 * @extends BaseApiClient
 */
var RegionsApiClient = /** @class */ (function (_super) {
    tslib_1.__extends(RegionsApiClient, _super);
    function RegionsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get all regions from BFF
     * @throws {RequiredError}
     * @memberof RegionsApiClient
     */
    RegionsApiClient.prototype.getRegions = function () {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(REGIONS_ENDPOINTS.ALL, fetchOptions);
    };
    return RegionsApiClient;
}(BaseApiClient));
export { RegionsApiClient };
//# sourceMappingURL=RegionsApiClient.js.map